import React, { useEffect, useRef, useState } from "react";
import "./TimeLine.css";
import Img from "../../assets/TimeLine/TimelineImage1.jpg";
import Img1 from "../../assets/aboutImg/timeline-item-image-2.jpg";
import Img2 from "../../assets/aboutImg/timeline-item-image-3.jpg";
import img3 from "../../assets/aboutImg/time_line_img.jpg";
import img4 from "../../assets/aboutImg/Timeline_img.jpg";
// import img5 from "../../assets/aboutImg/3.jpg"

const TimeLine = () => {
  const lineRef = useRef(null); // Ref for the yellow line
  const eventsRef = useRef([]); // Refs for timeline events
  const [activeDot, setActiveDot] = useState(0);
  const [activeEvent, setActiveEvent] = useState(-1); // To track which event is active

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight =
        document.documentElement.scrollHeight - window.innerHeight; 
      const scrollProgress = window.scrollY / totalHeight; 

      const maxLineHeight = 3500; // Adjust for max line height
      const newLineHeight = scrollProgress * maxLineHeight;

      // Update yellow line height
      if (lineRef.current) {
        lineRef.current.style.height = `${newLineHeight}px`;
      }

      // Update active dot and event visibility
      if (eventsRef.current.length > 0) {
        for (let i = 0; i < eventsRef.current.length; i++) {
          const event = eventsRef.current[i];
          if (event) {
            const eventTop = event.offsetTop - window.innerHeight / 2; // Event activation point

            if (window.scrollY >= eventTop) {
              setActiveDot(i + 1);
              setActiveEvent(i); // Activate this event
            }
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="timeline-container">
      {/* Vertical Yellow Line */}
      <div className="line" ref={lineRef}></div>

      {/* Timeline Events */}
      {[
        {
          year: "2016",
          description:"Our journey began with the establishment of ‘Adiverse Technologies LLP’ as a consulting company",
          img:Img
        },
        {
          year: "2018",
          description:"launched the ‘Money Lending ’ application, which has recieved massive appluads from our clients",
          img:Img1
        },
        {
          year: "2020",
          description:"Founded Aspiron Technologies with 20+ members, developing ERP solutions for educational institutions under One Data, One Nation.",
          img:Img2
        },
        {
          year: "2022",
          description: "Launched 'ADHIKRIT,' a software suite streamlining administration, academics, finance, OBE integration, exams, and attendance in educational institutes.",
          img:img3
        },
        {
          year: "2024",
          description: "Now we are a team of 100+and successfully implemented our “ADHIKRIT” solutions in over 30+ reputed educational institutions and counting.",
          img:img4
        },
        
        
      ].map((event, index) => (
        <div
          key={index}
          className={`event ${activeDot > index ? "visible" : ""}`} // Add 'visible' class when active
          ref={(el) => (eventsRef.current[index] = el)} // Attach ref to each event
        >
          <div
            className={`circle ${activeDot > index ? "filled" : ""}`} // Fill the circle dynamically
          ></div>
          <div
            className="content"
            // data-aos-delay="100"
            // data-aos="fade-in"
            data-aos-offset="200"
            // data-aos-easing="ease-in-sine"
            data-aos-duration="800"
          >
            {/* Conditionally reveal content */}
            <div className={`timeline_year ${activeDot > index ? "show" : ""}`}>
              <h3>{event.year}</h3>
              <p>{event.description}</p>
            </div>
            <img
              src={event.img}
              alt="Timeline Event"
              className={`${activeDot > index ? "show" : ""}`} // Show image when active
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default TimeLine;
